var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-result",style:({ backgroundColor: _vm.backgroundColor })},[_vm._t("icon",function(){return [_c('YorkbbsImage',{staticClass:"m-auto",attrs:{"width":"305px","height":"150px","src":_vm.icon}})]}),_vm._t("default",function(){return [_c('div',{staticClass:"empty-result__text"},[_vm._v(_vm._s(_vm.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }